module.exports = __webpack_public_path__ + "static/pokoj-nr5-photo05-66753b2106894634564d319051a4551f.jpg";